<template>

<li class="submenu">

  <router-link  v-if="folder.SubmenusQueMePertenecen.length <=0 && folder.EsDescarga==false && folder.RutaParaAccesar.split('//')[0] != 'https:' && folder.RutaParaAccesar.split('//')[0] != 'http:'" :to="folder.RutaParaAccesar" class="dropdown-item nav-link titulo" >
              {{folder.Titulo}}
  </router-link>  

  <a  v-else-if="folder.SubmenusQueMePertenecen.length <=0 && folder.EsDescarga==false && folder.SeMuestraEnVisor==false && (folder.RutaParaAccesar.split('//')[0] == 'https:' || folder.RutaParaAccesar.split('//')[0] == 'http:') " v-on:click="folder.Mostrar=!folder.Mostrar,AbrirPaginaExterna(folder.RutaParaAccesar,'_blank')" target="_blank" class="dropdown-item nav-link " >
      {{folder.Titulo}}
    </a>

   <a  v-else-if="folder.SubmenusQueMePertenecen.length <=0 && folder.EsDescarga==true && folder.SeMuestraEnVisor==false " v-on:click="folder.Mostrar=!folder.Mostrar,AbrirArchivo(folder.RutaParaAccesar,'_self')"  v-bind:class="{'dropdown-toggle':!folder.EsDescarga}" target="_blank" class="dropdown-item nav-link " >
      {{folder.Titulo}}
    </a>
     <a  v-else-if="folder.SubmenusQueMePertenecen.length <=0 && folder.EsDescarga==true && folder.SeMuestraEnVisor==true" v-on:click="folder.Mostrar=!folder.Mostrar,AbreElVisor(folder.RutaParaAccesar)"  v-bind:class="{'dropdown-toggle':!folder.EsDescarga}" target="_blank" class="dropdown-item nav-link " >
      {{folder.Titulo}}
    </a> 

 <a v-else class="nav-link dropdown-item dropdown-toggle" v-on:click="folder.Mostrar = !folder.Mostrar;">{{folder.Titulo}}
 </a>
    <ul  v-if="folder.Mostrar && folder.SubmenusQueMePertenecen && folder.SubmenusQueMePertenecen.length > 0" class="contenedorSubmenus">
      <folder v-for="child in folder.SubmenusQueMePertenecen" v-bind:key="child.index" v-bind:folder="child"></folder>
    </ul>
</li>
</template>
<script>
import comun from "@/../static/js/comun";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
export default {
  name:"folder",
    props:{
        folder: Object
        
    },
  methods: {
  
    AbreElVisor: function(vinculo) { 

       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
AbrirPaginaExterna: function(vinculo,forma) {
           window.open(vinculo,forma);
        },

         AbrirArchivo: function(vinculo,forma) {
         comun.DescargarDocumentoPDF(vinculo);
          //  window.open(vinculo,forma);
        },
  },
  
  
}
</script>


<style scoped>
.titulo{
  align-content: flex-start;
  padding-left: 2px;

}

.nav-link{
color: white !important;
margin-top: 0;
font-size: 1rem;
}

.nav-link:hover >>> {
  background-color: rgb(126,127,116);
    }

.contenedorSubmenus{
  /* background-color: rgb(255, 0, 149); */
  display: inline;
  padding: 0;
}

.contenedorSubmenus li{
  list-style: circle;
}

.submenu{
  list-style: none;
  margin-left: 1em;
  margin-right: 1em;
  background-color: rgb(0,117,115);
  
}


@media only screen and (max-width:991px){
.submenu{
  list-style: none;
  margin: 0;
  padding-left: 1em;
   background-color: rgb(34,34,34);
  
}

}



</style>



// WEBPACK FOOTER //
// src/components/Micrositios/Comun/MenuMicrositio/SubmenuMicrositio.vue